var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('collective-detail',{attrs:{"breadcrumb-route":"backoffice-organizations","item-type":"organizations","item-type-single":"organization"}})}
var staticRenderFns = []

export { render, staticRenderFns }